import { useEventBus } from '@vueuse/core';

export interface Notification {
    message: string;
    type?: 'info' | 'error' | 'success';
}

export const useNotification = () => {
    const notificationBus = useEventBus<Notification>('notification-shown');

    const showInfoNotification = (message: string, type: 'info' | 'error' = 'info') => {
        notificationBus.emit({
            message,
            type,
        });
    };

    return {
        showInfoNotification,
        notificationBus,
    };
}; 